import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromToolbar from './toolbar.reducer';

export const selectToolbarState = createFeatureSelector<fromToolbar.State>(
    fromToolbar.toolbarFeatureKey
);

export const selectToolbarConfig = createSelector(
    selectToolbarState,
    (toolbar) => toolbar.config
);

export const selectActivatedDrawingTool = createSelector(
    selectToolbarState,
    (toolbar) => toolbar.activatedDrawingTool
);

export const isBookpageToolActivated = createSelector(
    selectToolbarState,
    (toolbar) => toolbar.bookpageToolActivated
);

export const selectIsBookpageToolEnabled = createSelector(
    selectToolbarState,
    (toolbar) => toolbar.bookpageToolEnabled
);

export const isColorPaleteActivated = createSelector(
    selectToolbarState,
    (toolbar) => toolbar.colorPaleteActivated
);

export const isDrawingMenuOpened = createSelector(
    selectToolbarState,
    (toolbar) => toolbar.drawingMenuOpened
);

export const isDrawingEnabled = createSelector(
    selectToolbarState,
    (toolbar) => toolbar.drawingToolsEnabled
);

export const selectIsFloatingToolbarOpened = createSelector(
    selectToolbarState,
    (toolbar) => toolbar.floatingToolbarOpened
);

/** Toolbar drawing menu position in relation to floating-toolbar*/
export const selectDrawingMenuPosition = createSelector(
    selectToolbarState,
    (toolbar) => toolbar.drawingMenuPosition
);

/** Stroke width for drawing tools */
export const selectStrokeWidth = createSelector(
    selectToolbarConfig,
    (config) => config.strokeWidth
);

/** Toolbar position */
export const selectToolbarPosition = createSelector(
    selectToolbarConfig,
    (config) => config.toolbarPosition
);

/** Stroke color for drawing tools */
export const selectStrokeColor = createSelector(
    selectToolbarConfig,
    (config) => config.strokeColor
);

/**
 * If the undo button is enabled or disabled.
 * returns true if the user is allowed/able to go one step backwards in history.
 */
export const isUndoButtonActivateable = createSelector(
    selectToolbarState,
    (state) => true
);

/**
 * If the redo button is enabled or disabled.
 * returns true if the user is allowed/able to go one step forward in history.
 */
export const isRedoButtonActivateable = createSelector(
    selectToolbarState,
    (state) => true
);

// `selectGoToParentInProcess` was deleted in Stage D.6 (write-path
// refactor). The flag lives on `ToolbarUiStateService` as a Signal;
// consumers read `toolbarUiState.goToParentInProcess` directly (or via
// `toObservable` when an Observable is required).
